import { uniqBy } from 'lodash';
import { ProductOptionsResponse } from '../interfaces/ProductOption/ProductOptionsResponse';
import { ProductOptionKey } from '../interfaces/ProductOption/ProductOptionKey';
import { ProductOption } from '../interfaces/ProductOption/ProductOption';

export const buildProductOptionKeys = (
  response: ProductOptionsResponse,
): ProductOptionKey[] =>
  response.keys.map((key, i) => ({
    key: key.name,
    nameTranslation: key.nameTranslation,
    values: uniqBy(
      response.options.map((option) => ({
        name: option.kvps[i].value,
        nameTranslation: option.kvps[i].valueNameTranslation,
      })),
      (x) => x.name,
    ),
  }));

export const getOptionUniqueIdentifier = (option: ProductOption): string =>
  option.kvps.map((kvp) => `${kvp.key}:${kvp.value}`).join('-');
